<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: "App",
  data(){
    return{
    }
  }
}
</script>

<style> html,
 body {
   width: 100%;
   box-sizing: border-box;
   padding: 0px;
   margin: 0px;
   background-color: #EAEDF4;
 }

 #app {
   font-family: "Avenir", Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   color: #2c3e50;
   widows: 100%;
   height: 100%;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue